import noAnalyticsDataCondition from '~/helpers/noAnalyticsDataCondition';
import nodePath from '~/helpers/nodePath';

const extractAnalyticsData = (element: HTMLElement) => {
  if (element.nodeType === Node.DOCUMENT_NODE) {
    return {};
  }

  const node = nodePath(element, noAnalyticsDataCondition)[0];

  return node.dataset
    ? {
      analyticsParentLabel: node.dataset.analyticsLabel,
      analyticsParentService: node.dataset.analyticsService,
      analyticsParentComponent: node.dataset.analyticsComponent,
    }
    : {};
};

export default extractAnalyticsData;
